'use client';

import { useState } from 'react';

import { CardDefinition, TextNumber } from '@/types';
import Cards from '@/components/Cards';
import Button from '@/components/Button';
import SectionTitle from '@/components/SectionTitle';
import Subheader from '@/components/Subheader';
import { useConfig } from '@/app/contexts/ConfigContext';

interface TextContentProps {
  items: CardDefinition[];
  textNumber: TextNumber;
}

const ITEMS_PER_PAGE = 9;

export default function TextContent({ items, textNumber }: TextContentProps) {
  const { wording, config } = useConfig();

  const [selectedState] = useState<string>('All');
  const [maxItems, setMaxItems] = useState(ITEMS_PER_PAGE);

  const filteredItems = items.filter(
    (item) => selectedState === 'All' || item.tags.includes(selectedState)
  );
  const itemsToDisplay = filteredItems.slice(0, maxItems);

  const sectionTitleKey =
    `page_${textNumber}_section_title` as keyof typeof wording;
  const subheaderKey =
    `page_${textNumber}_subheader_text` as keyof typeof wording;

  return (
    <section className='sm:max-w-[1400px] max-w-[390px] mx-auto sm:mt-16 mt-8 px-4'>
      <SectionTitle>{wording?.[sectionTitleKey]}</SectionTitle>
      <div className='flex items-end sm:gap-12 gap-6'>
        <Subheader className='mt-4'>{wording?.[subheaderKey]}</Subheader>
      </div>
      <Cards items={itemsToDisplay} />
      <div className='text-center sm:my-20 my-5'>
        {filteredItems.length > maxItems && (
          <Button
            variant='secondary'
            onClick={() => setMaxItems((prev) => prev + ITEMS_PER_PAGE)}
            themeBackgroundColor={config.theme.textColorDark}
            themeTextColor={config.theme.textColorLight}
          >
            {wording?.button_load_more}
          </Button>
        )}
      </div>
    </section>
  );
}
